export default "__VITE_ASSET__DENGm6Cn__"